class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      const openPopup = document.querySelector('.popup-toolDown.show');
      if (openPopup) openPopup.classList.remove('show');
      const activeCart = document.querySelector('.previewCart.active-tool');
      if (activeCart) activeCart.classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

function dacoRemoveDiscount() {
  localStorage.removeItem('storedDiscount');
  var discountInput = document.querySelector('.daco-discount-bar__input');
  if (discountInput) discountInput.value = '';
  var savingsRow = document.querySelector('[data-saved-discount-display]');
  if (savingsRow) savingsRow.style.display = 'none';
  fetch('/checkout?discount=', { method: 'GET', credentials: 'same-origin' })
    .catch(function(){})
    .finally(function() {
      fetch('/discount/', { credentials: 'same-origin' })
        .catch(function(){})
        .finally(function() {
          Shopify.getCart(function(cart) {
            if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
              window.sharedFunctions.updateSidebarCart(cart);
            }
          });
        });
    });
}

document.addEventListener('click', function(event) {
  var btn = event.target.closest('[data-remove-discount]');
  if (!btn) return;
  event.preventDefault();
  event.stopPropagation();
  dacoRemoveDiscount();
});

document.addEventListener('click', function(event) {
  var btn = event.target.closest('[data-daco-sidebar-atc]');
  if (!btn) return;
  event.preventDefault();
  event.stopPropagation();
  if (btn.classList.contains('is-loading')) return;
  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;
  btn.classList.add('is-loading');
  fetch(window.routes.root + '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
  })
  .then(function(response) { return response.json(); })
  .then(function() {
    Shopify.getCart(function(cart) {
      if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
        window.sharedFunctions.updateSidebarCart(cart);
      }
      var $body = document.querySelector('body');
      var countEls = $body.querySelectorAll('[data-cart-count]');
      countEls.forEach(function(el) { el.textContent = cart.item_count; });
    });
  })
  .catch(function() {
    btn.classList.remove('is-loading');
  });
});